<template>
	<page>
		<module>
			<view-list work-type="45" ref="view" selector :view-config="auth('b_quality_work_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="质检单号">
							<c-input name="quality_code"></c-input>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="approve_states" :options="auditState2Dic" multiple></c-select>
						</m-search-item>
						<m-search-item label="质检时间" colspan="2">
							<c-datetime range start-name="test_date_start_date" end-name="plan_delivery_end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_quality_work_create')" v-lock="lock('b_quality_work_create')" prepend-icon="tf-add" @click="editOrder()">创建质检单</c-button>
					<c-button v-if="auth('b_quality_work_export')" v-lock="lock('b_quality_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_work_export')" v-lock="lock('b_quality_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_quality_work_export')" v-lock="lock('b_quality_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_work_export')" v-lock="lock('b_quality_work_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_quality_work_print')" v-lock="lock('b_quality_work_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_quality_work_log')" v-lock="lock('b_quality_work_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #quality_code="{data}">
					<c-link @click="globalDialog('qualityWorkDetail', {props: {id: data.id}})">{{data.quality_code}}</c-link>
				</template>

				<!--备注-->
				<template #remark="{data}">
					{{data.remark||'-'}}
				</template>

				<!--审核状态-->
				<template #approve_state="{data}">
					<c-state dict="auditState2Dic" :value="data.approve_state"></c-state>
				</template>
				
				<!--审核人-->
				<template #approve_user_realname="{data}">
					<span v-if="data.approve_state == 2">{{data.approve_user_realname}}</span>
					<span v-else>-</span>
				</template>
				
				<!--审核时间-->
				<template #approve_date="{data}">
					<span v-if="data.approve_state == 2">{{data.approve_date}}</span>
					<span v-else>-</span>
				</template>
				
				<!--质检良品率-->
				<template #test_fine_ratio="{data}">
					{{parseFloat((data.test_fine_count*100/data.test_count).toFixed(6))}}%
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_quality_work_edit')" v-lock="lock('b_quality_work_edit')" :disabled="!(data.approve_state == 1)" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('qualityWorkDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_quality_work_print')" v-lock="lock('b_quality_work_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_quality_work_approve')" v-lock="lock('b_quality_work_approve')" :disabled="!(data.approve_state == 1)" icon="tf-approve" @click="approve(data)">审批</c-table-button>
						<c-table-button v-if="auth('b_quality_work_approve')" v-lock="lock('b_quality_work_approve')" :disabled="!(data.approve_state == 2)" icon="tf-recall" @click="cancelApprove(data)">撤回</c-table-button>
						<c-table-button v-if="auth('b_quality_work_delete')" v-lock="lock('b_quality_work_delete')" :disabled="!(data.approve_state == 1)" icon="tf-trash" color="red" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑质检单信息弹窗-->
			<quality-work-edit ref="qualityWorkEdit" @resolve="$refs.view.update()"></quality-work-edit>
		</module>
	</page>
</template>

<script>
	import qualityWorkEdit from '@/pages/quality/quality_work_edit.vue'
	import {mapState} from 'vuex'

	export default {
		components: {
			qualityWorkEdit
		},
		
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['auditState2Dic'])
		},
		
		methods: {
			
			/******新建/编辑质检单*******/
			editOrder(data) {
				this.$refs.qualityWorkEdit.open(data);
			},

			/******审批***********/
			approve(data){
			    this.request({
			        url: '/quality/work/editState',
			        data: {
						id:data.id,
						approve_state: 2
					},
			        loading: true,
			        success: data => {
			            this.$message({
			                message:'审批成功',  // 提示内容,
			                type: 'success'
			            });
			            this.$refs.view.update();
			        }
			    });
			},
			
			/******撤销审批***********/
			cancelApprove(data){
				this.$confirm({
					message:'撤回后质检单【'+data.quality_code+'】将回滚至待审批状态，是否确认撤回？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/quality/work/editState',
							data: {
								id:data.id,
								approve_state: 1
							},
							loading: true,
							success: data => {
								this.$message({
									message:'撤回成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除质检单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除质检单【'+data.quality_code+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/quality/work/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>